import { IChannel } from "@/ts/common-types";
import { Tag } from "antd";
import React from "react";
import { useSelector } from "react-redux";

interface IWinningBidRangeRenderer {
    bidType: string;
    params: any;
    identifier: number;
}

const WinningBidRangeRenderer: React.FC<IWinningBidRangeRenderer> = ({
    params,
    bidType,
    identifier
}) => {
    const currencySymbol = useSelector(
        (state: IChannel) => state.channelCurrencySymbol.value
    );
    const minSuggestedBid =
        params.data[`${bidType.toLowerCase()}_suggested_min`];
    const maxSuggestedBid =
        params.data[`${bidType.toLowerCase()}_suggested_max`];
    return (
        <>
            {minSuggestedBid && maxSuggestedBid ? (
                <Tag
                    id={`${identifier}-${bidType}-winning-limit-span`}
                    className="mt-2"
                    color="blue"
                    style={{
                        fontSize: "10px",
                        ...(
                            bidType === "Smart" && { display: params.data.is_smart ? "inline-block" : "none" }
                        )
                    }}
                >
                    {`Bid Range: 
        ${currencySymbol}${minSuggestedBid} - ${currencySymbol}${maxSuggestedBid}`}
                </Tag>
            ) : (
                ""
            )}
        </>
    );
};

export default WinningBidRangeRenderer;
